// extracted by mini-css-extract-plugin
export var accountCreatedText = "pages-auth-__AccountCreated-module___accountCreatedText";
export var resendEmailButton = "pages-auth-__AccountCreated-module___resendEmailButton";
export var submitButton = "pages-auth-__AccountCreated-module___submitButton";